export const API = {
  LOGIN: {
    URL: "/auth/login",
    METHOD: "POST",
  },
  LOGOUT: {
    URL: "/auth/logout",
    METHOD: "POST",
  },
  GET_CURRENT_USER: {
    URL: "/users",
    METHOD: "GET",
  },
  GET_LIST_USERS: {
    URL: "/users/list",
    METHOD: "GET",
  },
  CREATE_USER: {
    URL: "/users",
    METHOD: "POST",
  },
  UPDATE_USER: {
    URL: "/users/:id",
    METHOD: "PUT",
  },
  UPDATE_USER_PROFILE: {
    URL: "/profile/:id",
    METHOD: "PUT",
  },
  CREATE_USER_PROFILE: {
    URL: "/profile",
    METHOD: "POST",
  },
  REFRESH_TOKEN: {
    URL: "/auth/refresh",
    METHOD: "POST",
  },
  GET_CLASSES: {
    URL: "/classes",
    METHOD: "GET",
  },
  GET_CLASS: {
    URL: "/classes/:id",
    METHOD: "GET",
  },
  CREATE_CLASS: {
    URL: "/classes",
    METHOD: "POST",
  },
  UPDATE_CLASS: {
    URL: "/classes/:id",
    METHOD: "PUT",
  },
  DELETE_CLASS: {
    URL: "/classes/:id",
    METHOD: "DELETE",
  },
  GET_STUDENTS_BY_CLASS: {
    URL: "/classes/:classId/students",
    METHOD: "GET",
  },
  CREATE_STUDENT: {
    URL: "/classes/:classId/students",
    METHOD: "POST",
  },
  UPDATE_STUDENT: {
    URL: "/students/:id",
    METHOD: "PUT",
  },
  DELETE_STUDENT: {
    URL: "/students/:id",
    METHOD: "DELETE",
  },
  QUERY_ATTENDANCE: {
    URL: "/attendance",
    METHOD: "GET",
  },
  GET_SCHOOLS: {
    URL: "/schools",
    METHOD: "GET",
  },
  CREATE_SCHOOL: {
    URL: "/schools",
    METHOD: "POST",
  },
  UPDATE_SCHOOL: {
    URL: "/schools/:id",
    METHOD: "PUT",
  },
  GET_TEACHERS: {
    URL: "/teachers",
    METHOD: "GET",
  },
  CREATE_TEACHER: {
    URL: "/teachers",
    METHOD: "POST",
  },
  UPDATE_TEACHER: {
    URL: "/teachers/:id",
    METHOD: "PUT",
  },
  DELETE_TEACHER: {
    URL: "/teachers/:id",
    METHOD: "DELETE",
  },
};
